import { ToastifyType } from './global'

export const NOTIFICATIONS_INITIAL_STATE = {
  message: '',
  type: ToastifyType.DEFAULT,
}
